import { AdvisorsLayout, BrowseSection } from '@src/components/sco/Advisors'
import { advisorsBrowseSeo } from '@src/components/sco/Advisors/utils/advisorsSeo'
import { usePageSEO } from '@src/hooks/usePageSEO'

export { getServerSideProps } from '@src/lib/server-side-rendering'

/** Guest-reachable and server-rendered (L3). */
export default function Page() {
  usePageSEO(advisorsBrowseSeo())

  return (
    <AdvisorsLayout>
      <BrowseSection />
    </AdvisorsLayout>
  )
}
